import React, { useContext, useEffect, useState } from "react";
import { Button } from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { UserImageContext } from "../../context/usecontextImage";
import { usecontextUser } from "../../context/usecontextUser";

function Signin() {
  const { login } = useContext(usecontextUser);
  
  const { t } = useTranslation();
  const { userImage, updateUserImage } = useContext(UserImageContext);

  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");

  const apilink = process.env.REACT_APP_API_URL + "login";

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(apilink, {
        mobile,
        password,
      });
      console.log(response.data);
      login(response.data)
      // localStorage.setItem("token", response.data.access_token);
      // localStorage.setItem("username", response.data.data.name);
      // localStorage.setItem("user_id", response.data.data.id);
      // localStorage.setItem("user_type", response.data.data.user_type_id);
      // localStorage.setItem("user_gender", response.data.data.gender_id);
      // localStorage.setItem("user_image", response.data.data.image);
      // localStorage.setItem("user_email", response.data.data.email);
       updateUserImage(process.env.REACT_APP_IMAGE + response.data.data.image);
      navigate("/");
    } catch (error) {
      console.error("Login failed:", error);
      alert("login failed");
    }
  };

  return (
    <div>
      <div className="container">
        <h2 style={{ textAlign: "center", margin: "50px" }}>
          {t("SignIn.signin")}
        </h2>

        <div
          style={{
            textAlign: "center",
            borderRadius: "8px",
            padding: "16px",
            border: "1px solid",
            width: "450px",
            boxshadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
            margin: "0 auto",
          }}
          className="row"
        >
          <div style={{ fontWeight: 300 }} className="col-md-12">
            {t("SignIn.welcome")}
          </div>
          <div className="col-md-12 my-4">
            <input
              type="text"
              className="form-control"
              placeholder="Mobile Phone"
              autoComplete="off"
              name="mobile"
              id="mobile"
              onChange={(e) => setMobile(e.target.value)}
            />
          </div>
          <div className="col-md-12">
            <input
              type="password"
              className="form-control"
              placeholder="Password"
              autoComplete="new-password"
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <div className="col-md-12 my-4">
            <Button
              sx={{
                background: "#232324",
                color: "#fff",
                fontFamily: "Oswald, cairo",
                fontSize: "16px",
                fontWeight: 300,
              }}
              onClick={handleSubmit}
            >
              {t("SignIn.buttontext")}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Signin;
